import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { mapAttemptDescription } from '../mappers/attempt-description.mapper.ts';
import { mapStepDetails } from '../mappers/step-details.mapper.ts';
import { mapTaskDetails } from '../mappers/task-details.mapper.ts';

import { selectCurrentLessonTaskStep } from './current-lesson-task-step.selector.ts';

export const selectCurrentAttemptDescription = createMemoizedSelector(selectCurrentLessonTaskStep, ({ task, step }) => {
  const taskDetails = mapTaskDetails(task);
  const stepDetails = mapStepDetails(step);

  return mapAttemptDescription(taskDetails, stepDetails);
});
